<script setup lang="ts">
import { WikiProps } from "./Wiki.props"

const { path } = defineProps<WikiProps>()
</script>

<template>
  <div
    @click="navigateTo(path)"
    class="
      wrapper-wiki-card
      cursor-pointer
      rounded-lg
      bg-white
      p-4
      shadow-01
      hover:shadow-02
    "
  >
    <h4 class="dolphin-bold mb-2 text-green-main">
      <AppLink :to="path">{{ title }}</AppLink>
    </h4>
    <p class="mouse">
      <span class="line-clamp-2">
        {{ text }}
      </span>
      <span class="mouse-bold text-green-main underline">
        {{ $t("wiki.categories.keepReading") }}
      </span>
    </p>
  </div>
</template>
